import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IStory } from "../../type";
import { New } from "../../components/New";
import { viewedStory } from "../../api/story";
import "./index.css";

interface IProps {
  user_id: number;
  stories: IStory[];
  reload_stories: () => void;
}

export function Story(props: IProps) {
  const { storyId } = useParams<{ storyId: string }>();
  const [huiId, setHuiID] = useState<number>(0);
  const activeStoryId = +(huiId || storyId || 0);
  const story = props.stories.find((item) => item?.id === activeStoryId) as IStory | undefined;
  const news = story?.News_IntoStorysRelation || [];
  const lengthN = news.length;
  const lengthS = props.stories.length;
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(0);

  // Если история или новости обновляются, сбрасываем страницу на 0
  useEffect(() => {
    setPage(0);
    setHuiID(+(storyId||0));
  }, [storyId]);

  useEffect(() => {
    if (!props.stories.length) {
      navigate("/");
    }
  }, [props.stories, navigate]);

  const handleNext = () => {
    if (!story || !story.id || !news.length || !Array.isArray(props.stories) || !props.stories.length) {
      navigate("/");
      return;
    }
    if (page < lengthN - 1) {
      setPage(page + 1); // Переход к следующей новости
    } else {
      const currentStoryIndex = props.stories.findIndex((s) => s?.id === story.id);
      if (currentStoryIndex < 0) {
        navigate("/");
        return;
      }
      const nextStoryIndex = currentStoryIndex + 1;
      if (nextStoryIndex < lengthS) {
        const nextStory = props.stories[nextStoryIndex];
        const nextStoryId = nextStory?.id;
        if (!nextStoryId) {
          navigate("/");
          return;
        }
        setPage(0);
        setHuiID(nextStoryId); //navigate(`/story/${nextStoryId}`);
        viewedStory(props.user_id, story.id);
      } else {
        viewedStory(props.user_id, story.id).then(()=>{
          navigate("/"); // Переход на главную страницу, если это последняя история
        });
      }
    }

    props.reload_stories();
  };

  const handlePrevious = () => {
    if (!story || !story.id || !news.length || !Array.isArray(props.stories) || !props.stories.length) {
      navigate("/");
      return;
    }
    if (page > 0) {
      setPage(page - 1); // Переход к предыдущей новости
    } else {
      const currentStoryIndex = props.stories.findIndex((s) => s?.id === story.id);
      if (currentStoryIndex < 0) {
        navigate("/");
        return;
      }
      const prevStoryIndex = currentStoryIndex - 1;
      if (prevStoryIndex >= 0) {
        const prevStory = props.stories[prevStoryIndex];
        const prevStoryId = prevStory?.id;
        if (!prevStoryId) {
          navigate("/");
          return;
        }
        setHuiID(prevStoryId);//navigate(`/story/${prevStoryId}`);
      } else {
        navigate("/"); // Переход на главную страницу, если это первая история
      }
    }

    props.reload_stories();
  };

  return (
    <section className="section mainPage flex flex-column bcw">
      <div className="progressBar">
        {news.map((_, index) => (
          <div key={index} className={index <= page ? "active" : ""} />
        ))}
      </div>

      {news.length > 0 && (
        <New
          Id={news[page].Id}
          url={news[page].url}
          onNextClick={handleNext}
          onPreviousClick={handlePrevious}
        />
      )}

      <div className="navButton left" onClick={handlePrevious}></div>
      <div className="navButton right" onClick={handleNext}></div>
    </section>
  );
}
